import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/app/[locale]/branchen/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/client/link.js");
